import React from 'react';
import Logo from '@wix/da-ds/pkg/Logo';
const LogoWithCoreLevel = (props)=>{
    return /*#__PURE__*/ React.createElement(Logo, props);
};
LogoWithCoreLevel.displayName = 'LogoWithCoreLevel';
export default LogoWithCoreLevel;
